<template lang="html">
    <div>
        <!-- 회원 상세, 관심 카테고리 -->
        <UserDetail v-bind:userId="user_id" />
        <!-- 탭영역 -->
        <UserTabs v-bind:userId="user_id" />
    </div>
</template>
<script>
import UserDetail from './component/UserDetail'
import UserTabs from './component/UserTabs'

export default {
    name: "userManagementDetail",
    data() {
        return {
            user_id: "",
        }
    },
    components: {
        UserDetail,
        UserTabs,
    },
    mounted() {
        // 처음 들어왔을때 user_id 가 있어야 합니다.
        this.user_id = this.$session.get('usermanage_user_id');
        // console.log('================>', this.user_id);
    },
    methods: {
        
    },
}
</script>



// WEBPACK FOOTER //
// src/views/user/userDetail/userManagementDetail.vue